/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ExportLogEntryStatus } from '../enums/export-log-entry-status.enum';

//<custom-head>
import { formattedDate, parseDate } from 'app/utils';
import { ExportLogEntryStatusLookup } from 'app/translations';
//</custom-head>

export class ExportLogStatusChangeDto {
  public id: number = undefined;
  public exportLogEntryId: number = undefined;
  public fromStatus: ExportLogEntryStatus;
  public toStatus: ExportLogEntryStatus;
  public responseData: string = undefined;
  public timestampUtc: Date | string;

  //<custom-body>
  constructor(source: ExportLogStatusChangeDto) {
    Object.assign(this, source);
  }

  public get formattedDate(): string {
    return formattedDate(parseDate(this.timestampUtc));
  }

  public get translatedToStatus(): string {
    if(this.fromStatus || this.fromStatus == 0){
      return `${ExportLogEntryStatusLookup.translate(this.fromStatus)} <i class="fa fa-long-arrow-right"></i> ${ExportLogEntryStatusLookup.translate(this.toStatus)}`;
      }
    return `${ExportLogEntryStatusLookup.translate(this.toStatus)}`
  }
  //</custom-body>
}
